import axios from 'axios';

// const baseDomain = "https://editor.aws.key2print.com/api/v1";
// const baseURL = `${baseDomain}`;

let Repository = {};

// Repository = axios.create({
//     baseURL,
// });

export const setRepositoryUrl = (baseURL) => {
    Repository = axios.create({
        baseURL,
    })
};

export const getRepository = () => {
    return Repository;
};

// export default Repository;
// export default axios.create({
//     baseURL,
// })

